export const ImageSource = {
    None : "None",
    Default : "Default",
    Arigo : "Arigo",
    GS1 : "GS1",
    Custom : "Custom"
}
export const ProductFilterProductTypes = {
    ALL:"all",
    NONE:"none",
    MVP:"mvp",
    ONTOP:"ontop",
    MVP_AND_ONTOP:"mvp_and_ontop",
}
export const ProductFilterArchivedTypes = {
    ALL:"All",
    ARCHIVED:"Archived",
    NOT_ARCHIVED:"Not_archived",
}

export const MPProductMissingTypes = {
    Dimension_Missing : "dimension_missing",
    Brand_Missing : "brand_missing",
    /* Image_Missing : "image_missing",
    SubCategory_Missing : "subcategory_missing",
    Category_Missing: "category_missing",
    Department_Missing: "department_missing",
    Entire_Hierarchy_Missing: "entire_hierarchy_missing" */
}
export const MasterProductMissingTypes = {
    Dimension_Missing : "dimension_missing",
    // Image_Missing : "image_missing",
    Brand_Missing : "brand_missing",
     SubCategory_Missing : "subcategory_missing",
}


export const ProductSearchCritieriaTypes = {
    NONE:"none",
    Equal:"equal",
    Range:"range"
}

export const MasterProductCompleteStatus = {
    None:"None",
    DataMissing:"DataMissig",
    FullData:"FullData"
}

export const FilterDateSearchTypes = {
    dateRange: "dateRange",
    dateCount: "dateCount",
}

export const NewProdSendTypes = {
    Archive: 'archive',
    SendToDep: 'sendtodep',
    Restore: 'restore',
}

export const ProductOrigin = {
    Manual: "Manual",
    POS: "POS",
    Arigo: "Arigo",
    GS1: "GS1",
    Other: "Other"
}

export const POSHeirarchyCompleteStatus = {
    NO_DATA: "No Data",
    HAVING_DATA: "Having Data",
    INVALID_DATA: "Invalid Data",
    OTHER: "Other",
}

export const ProductFilterHangableTypes = {
    ALL : "All",
    HANGABLE : "Hangable",
    NOT_HANGABLE : "Not_hangable",    
}
